export { NetworkState, NetworkStatus } from './network-state.service';
export { NetworkStateModule } from './network-state.module';
